import {onFind, initInScope} from "@elements/init-modules-in-scope";
import {on, findIn, findAllIn, closest, addClass, removeClass, off, removeAttribute} from "@elements/dom-utils";
import formDataEntries from 'form-data-entries';
import {clearAll, showNotification} from "@elements/alert-notification";

const selectors = {
    base: '.js-quick-capture',
    loading: '.js-quick-capture__loading',
    form: '.js-quick-capture__form',
    buttons: '.js-quick-capture__btn',
    containers: '.js-quick-capture__container',
    tablerow: '.js-quick-capture__row',
    result: '.js-quick-capture__result',
    tablerowResult: '.js-quick-capture__row-result',
    error: '.js-quick-capture__error',
    errorMessage: '.js-quick-capture__error-message',
    price: '.js-quick-capture__price',
    total: '.js-quick-capture__total',
};

export function init() {
    onFind(selectors.tablerow, (tablerow) => {
        let base = closest(selectors.base, tablerow)
        let form = findIn(selectors.form, base);
        let loading = findIn(selectors.loading, base);
        let buttons = findAllIn(selectors.buttons, base);
        let rows = findAllIn(selectors.tablerow, base);
        let errorMessage = findIn(selectors.errorMessage, base);

        const changeTableRow = function (event) {
            event.preventDefault;
            loading.removeAttribute('hidden');

            let url = tablerow.getAttribute('data-action');
            let content = tablerow.getElementsByTagName('input')
            let data = new FormData();
            let table = closest("table", tablerow);

            for(let index = 0; index < content.length; index++){
                data.append(content[index].name, content[index].value)
            }

            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }

            let pendingRequest = fetch( url, {
                method: "POST",
                body: data
            } );

            pendingRequest.then((res) => {
                return res.clone().json()
            }).then((res) => {
                console.log("res", res)
                if (res.success) {
                    let rowResult = findAllIn(selectors.tablerowResult, tablerow);

                    for(let index = 0; index < rowResult.length; index++){
                        if (!res.foundArticle){
                            addClass('text-muted', rowResult[index])
                        }else{
                            removeClass('text-muted', rowResult[index])
                        }

                        if (rowResult[index].getAttribute('data-content') === "description" && res.description){
                            rowResult[index].innerText = res.description
                        }
                        if (rowResult[index].getAttribute('data-content') === "material" && res.material){
                            rowResult[index].innerText = res.material
                        }
                        if (rowResult[index].getAttribute('data-content') === "price" && (res.price || res.price === 0)){
                            rowResult[index].innerText = res.formattedPrice
                            rowResult[index].setAttribute('data-price', res.price)
                            rowResult[index].setAttribute('data-currency', res.currency)
                        }
                    }

                    //calculate price
                    let prices = findAllIn(selectors.price, table);
                    let total = 0;
                    let currency = '€'

                    prices.forEach((price) => {
                        let priceData = price.getAttribute('data-price');
                        currency = price.getAttribute('data-currency');

                        if (priceData) {
                            total += parseFloat(priceData);
                        }
                    })

                    let totalPrice = findIn(selectors.total, base);
                    totalPrice.innerHTML = currency + ' ' + total.toFixed(2).replace('.', ',');
                }else{
                    errorMessage.innerText = res.error;
                    errorMessage.removeAttribute('hidden');
                }

                loading.setAttribute('hidden', true);
            }).catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error(error);

                    error.removeAttribute('hidden');

                    loading.setAttribute('hidden', true);
                }
            });

        }

        //change amount/article in table
        on('change', changeTableRow, tablerow)

        return {
            cleanUp: () => {
                off("change", changeTableRow , tablerow);
            }
        };
    })


    onFind(selectors.buttons, function (btn) {
        let base = closest(selectors.base, btn);
        let form = closest(selectors.form, btn);
        let loading = findIn(selectors.loading, base);

        const buttonClick = function (event) {
            event.preventDefault;
            loading.removeAttribute('hidden');
            let container = closest(selectors.containers, btn);
            let currentAction = container.getAttribute('data-action');

            let url = btn.getAttribute('data-action');
            let formContent = form;
            let data = new URLSearchParams(formDataEntries(formContent));

            let input = data.get(currentAction);

            if ((input !== "" && input !== null) || currentAction ==="template"){
                if (currentAction !== "template"){
                    data.delete('template')
                }
                if(currentAction !== "cart"){
                    data.delete('cart')
                }
                if(currentAction !== "new-cart"){
                    data.delete('new-cart')
                }

                if (pendingRequest) {
                    pendingRequest.abort();
                    pendingRequest = null;
                }

                let pendingRequest = fetch( url, {
                    method: "POST",
                    body: data
                } );

                showNotification({closable: true});
                showNotification(pendingRequest);

                //close notification after 3 seconds => customer request workfront ticket: 1863705
                setTimeout(() => {
                    clearAll();
                }, 3000);

                pendingRequest.then((res) => {
                    return res.clone().json()
                }).then((res) => {
                    if (res.success) {
                        if (res.redirect) {
                            window.location.href = res.redirect;
                        }
                    }

                    loading.setAttribute('hidden', true);

                }).catch((error) => {
                    if (error.name !== 'AbortError') {
                        console.error(error);

                        loading.setAttribute('hidden', true);
                    }
                });
            }else {
                let error = findIn(selectors.error, container);
                error.innerHTML = "Bitte Wert eingeben";
                loading.setAttribute("hidden", true)
            }
        }



        on("click", buttonClick , btn)



        return {
            cleanUp: () => {
                off("click", buttonClick , btn);
            }
        };
    });
}
